import { render, staticRenderFns } from "./DepartamentoPessoalGet.vue?vue&type=template&id=fcb3fb1c&scoped=true"
import script from "./DepartamentoPessoalGet.vue?vue&type=script&lang=js"
export * from "./DepartamentoPessoalGet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcb3fb1c",
  null
  
)

export default component.exports